import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Table,
  TableBody,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Edit from '@mui/icons-material/Edit';
import AddressDialog from 'src/components/AddressDialog/AddressDialog';
import AddressDetailBox from 'src/components/AddressDetailBox/AddressDetailBox';
import { editInvestor } from 'src/store/actions/investorActions';
import { useParams } from 'react-router-dom';
import useStyles from '../../styles';

const InvestorAddress = ({ investor }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { id } = useParams();
  const [open, setOpen] = useState(false);

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleSubmit = useCallback(
    values => {
      dispatch(editInvestor(id, { address: values }, () => setOpen(false)));
    },
    [investor, id]
  );

  return (
    <Card variant="elevation">
      <CardHeader
        className={classes.header}
        title={
          <Typography className={classes.tableCell} component="h4" variant="h4">
            {t('INVESTORS_VIEW.INVESTOR_DETAIL.INVESTOR_ADDRESS')}
          </Typography>
        }
      />
      <Divider className={classes.tableCell} />
      <CardContent style={{ padding: 0, marginBottom: '16px' }}>
        <Table>
          <TableBody>
            {investor?.address ? (
              <AddressDetailBox address={investor?.address} includeCountry />
            ) : null}
          </TableBody>
        </Table>
        <AddressDialog
          open={open}
          address={investor.address}
          handleClose={handleClose}
          submit={handleSubmit}
          includeCountry
          editableCountry
        />

        <Grid container direction="column" alignItems="stretch">
          <Grid item className={classes.buttons}>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              color="primary"
              className={clsx(classes.label, classes.buttons)}
              startIcon={<Edit />}
            >
              {investor?.address ? t('COMMON.EDIT') : t('COMMON.ADD')}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

InvestorAddress.propTypes = {
  investor: PropTypes.object.isRequired
};

export default InvestorAddress;
